import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import App from "./App";
import Setup from "./pages/Setup"
import Error from "./pages/Error";
import Placeholder from "./pages/Placeholder";
import './types/react-app-env.d.ts';
import './extensions/StringExtensions'
import LegacyPage from "./pages/LegacyPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <Error />,
    children: [
      {
        path: "",
        element: <Setup />,
      },
      {
        path: ":tenantId/:deviceName",
        element: <Placeholder />,
      },
      {
        path: "SPA/:tenantId/:deviceName/:controller",
        element: <LegacyPage />,
      }
    ],
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
